/**
 * Normalizes email: trims, lowercases, removes spaces
 * @param {string} email - Email to normalize
 * @returns {string} Normalized email
 */
export const normalizeEmail = (email) => {
    if (!email) {
        return '';
    }
    return email.trim().toLowerCase().replace(/\s/g, '');
};

/**
 * Normalizes platform name to lowercase
 * @param {string} platform - Platform name
 * @returns {string} Normalized platform
 */
export const normalizePlatform = (platform) => {
    if (!platform) {
        return '';
    }
    return platform.toLowerCase();
};

